import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash';

import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import messages from '../../messages';
import style from './preview-modal.module.less';

export const RateStatusIndicatorPlaceholder = ({ isActive }) => {
  const statusIcon = isActive ? (
    <FontAwesomeIcon className={style['check-icon']} icon={faCheck} />
  ) : (
    <FontAwesomeIcon className={style['hidden-icon']} icon={faEyeSlash} />
  );
  const statusMessage = isActive ? <FormattedMessage {...messages.activeStatus} /> : <FormattedMessage {...messages.inactiveStatus} />;

  return (
    <div className={style['status-indicator']}>
      {statusIcon}
      {statusMessage}
    </div>
  );
};

RateStatusIndicatorPlaceholder.propTypes = {
  isActive: PropTypes.bool.isRequired,
};
